export function vlen2(a) {
    return a.x * a.x + a.y * a.y;
}
export function vlen(a) {
    return Math.sqrt(vlen2(a));
}
export function vsub(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
export function vmul(a, s) {
    return { x: a.x * s, y: a.y * s };
}
export function vnorm(a) {
    return vmul(a, 1 / vlen(a));
}
export function vadd(a, b) {
    return { x: a.x + b.x, y: a.y + b.y };
}
export function vdot(a, b) {
    return a.x * b.x + a.y * b.y;
}
export function vrot(v, c, a) {
    if (a === 0)
        return v;
    const radians = (Math.PI / 180) * a, cos = Math.cos(radians), sin = Math.sin(radians), nx = cos * (v.x - c.x) - sin * (v.y - c.y) + c.x, ny = cos * (v.y - c.y) + sin * (v.x - c.x) + c.y;
    return { x: nx, y: ny };
}
